import React from 'react'
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'
import Notifications from 'react-notify-toast';
import AuthPage from './pages/AuthPage'
import HomePage from './pages/HomePage'
import './languages/I18n';
/* eslint-disable */
import * as locales from 'moment/min/locales'
/* eslint-enable */
import background from './images/background.jpg'
import 'react-select/dist/react-select.css';
import 'react-infinite-calendar/styles.css';
import './App.css'

const App = () => (
  <div style={{backgroundImage: `url(${background})`, position: 'absolute', top: 0, bottom: 0, width: '100%', backgroundSize: 'cover', backgroundPosition: 'center'}}>
      <Router>
        <div style={{height: '100%'}}>
          <Notifications options={{zIndex: 2000}}/>
          <Route exact path="/" component={AuthPage}/>
          <Route path="/home" component={HomePage}/>
        </div>
      </Router>
  </div>
)
export default App


// WEBPACK FOOTER //
// ./src/App.js